<template>
<div>
    <section class="pt-12 pt-md-14 mt-n11 bg-primary">
    </section>
    <section class="pt-8 pt-md-11 pb-12">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-12 col-md">
                    <h1 class="display-4 mb-2">Blog</h1>
                    <p class="text-muted mb-8">Weekly digests and industry news</p>
                </div>
            </div>
            <div class="row" v-if="loaded">
                <div class="col-12 col-md-8">
                    <div class="mb-5" v-for="a in posts" :key="a.slug">
                        <h5 class="mb-1">
                            <router-link :to="'/blog/' + a.slug" class="text-decoration-none">{{ a.title }}</router-link>
                        </h5>
                        <small class="text-muted" v-if="a.published">{{ formatDate(a.published) }}</small>
                        <p class="text-muted mt-1 mb-0" v-if="a.meta_description">{{ a.meta_description }}</p>
                    </div>
                    <p v-if="!posts.length" class="text-muted">No posts yet.</p>
                </div>
            </div>
        </div>
    </section>
</div>
</template>

<script>
export default {
    data() {
        return {
            posts: [],
            loaded: false,
        }
    },
    methods: {
        formatDate(d) {
            return new Date(d).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })
        }
    },
    created() {
        this.$services.BlogPosts().get().then(resp => {
            this.posts = resp.body
            this.loaded = true
        })
        this.$methods.updateSEOMeta({
            title: 'Blog - Weekly Digest',
            description: 'Weekly industry digests covering TikTok API updates, data scraping news, and platform changes.',
            keywords: 'TikTok API blog, weekly digest, API news, data scraping updates',
        }, '/blog')
    },
}
</script>
